// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"6ceba8bb","2414":"71a45a52","3285":"cc3e3f06","6386":"2ef51c6e","7260":"4f688c1b","9479":"031372e2"}[chunkId] + ".chunk.css";
};